import angular from 'angular';

export type TMovimentacaoAdmissaoFormVigencia = 1 | 2 | 3;

export interface IMovimentacaoAdmissaoFormModel {
    evento: any;
    lotacao: any;
    valor: string | number | null;
    referencia: string;
    vigencia: TMovimentacaoAdmissaoFormVigencia;
    vigenciamesfinal: number | null;
    vigenciaanofinal: number | null;
}

export interface IMovimentacaoAdmissaoFormState {
    valid: boolean;
    vigenciaFinalInvalida: boolean;
}

export interface IMovimentacaoAdmissaoFormBindings {
    model: IMovimentacaoAdmissaoFormModel;
    formRef?: angular.IFormController;
    admissionDate?: string | Date | null;
    disabled?: boolean;
    onValidityChange?: (args: { state: IMovimentacaoAdmissaoFormState }) => void;
}

export function createEmptyMovimentacaoAdmissaoForm(): IMovimentacaoAdmissaoFormModel {
    return {
        evento: null,
        lotacao: null,
        valor: null,
        referencia: '',
        vigencia: 1,
        vigenciamesfinal: null,
        vigenciaanofinal: null
    };
}
